export class FetchError extends Error {
    statusCode: number;
    constructor(response: Response) {
        super(`Error during REST call to ${response.url}: ${response.status} ${response.statusText}`);
        this.statusCode = response.status;
    }
}
